export const createMessage = (text, variant) => ({
    text,
    variant,
    show: true
});